/* eslint-disable import/prefer-default-export */
export const AVAILABILITY_BT_CONSTS = {
  AVAILABLE_CODES: ['ONHAND', 'QUICK'],
  ON_ORDER_CODES: ['PROMO', 'LVIP', 'BACKORDER', 'DIRECT'],
  AVAILABLE: 'available',
  ON_ORDER: 'onOrder',
  UNAVAILABLE_MESSAGES: [
    'This item is not available for delivery in your area',
    'This item is not available for delivery in your area.',
  ],
  INVALID_ZIPCODE_MCOM: 'Please enter a valid zip code.',
  INVALID_ZIPCODE_BCOM: 'Please enter a 5-digit Zip Code.',
};
